export default __webpack_public_path__ + "static/media/nasscom-green-tables.b10a5b8c.png";